(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const stickyHeader = document.querySelector('sticky-header')
    if (stickyHeader) {
      stickyHeader.setupWindowResizeEvent()
    }
  })

  } catch(e) { console.error(e); }
})();
})();
